import BaseUseCase from "../../base_use_case.js";

class UploadPdfUseCase extends BaseUseCase {

  execute(image) {
    let formData = new FormData();
    formData.append("pdf[attachment]", image)
    
    return this.httpClient({
      ...this.requestConfig(),
      method: "post",
      url: `/api/v1/assets/pdfs`,
      data: formData,
    });
  }

  requestConfig() {
    let config = super.requestConfig();
    config.headers["Content-Type"] = "application/x-www-form-urlencoded";
    return config;
  }
}

const instance = new UploadPdfUseCase();
export default instance;